<template>
<div class="c-step step-9">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy jest możliwość podpisania dokumentów u
      Państwa w domu?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step9',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '9',
        answer: answer
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
